import React, { useEffect, useState } from "react";
import { DashboardManagerFilter } from "../../../model/dashboard-manger-filter";
import { BaseList } from "../../../../../component/list/base-list";
import { columns } from "./cohort-student-average-rating-list-column-definition";
import { getCohortStudentAverageRatings } from "../../../service/dashboard-manager-service";
import BaseOperations from "../../../../../component/operations/base-operations";
import { CohortStudentAverageRating } from "../../../model/cohort-student-average-rating";

const storageKey = "DASHBOARD_MANAGER_STUDENT_AVERAGE_RATING"

export default function CohortStudentAverageRatingList({
    filter,
    setFilter
}: {
    filter: DashboardManagerFilter,
    setFilter: React.Dispatch<React.SetStateAction<DashboardManagerFilter>>,
}) {
    const [loading, setLoading] = useState(false);
    const [averageRatings, setAverageRatings] = useState<CohortStudentAverageRating[]>([]);

    useEffect(() => {
        if (filter.cohortId !== undefined) {
            setLoading(true);
            getCohortStudentAverageRatings(
                filter.cohortId,
                filter.studentId !== 0 ? filter.studentId : undefined
            ).then(result => {
                setAverageRatings(result);
                setLoading(false);
            }).catch(() => {});
        } else {
            setAverageRatings([]);
        }
    }, [filter.cohortId, filter.studentId]);

    return (
        <React.Fragment>
            <BaseList
                storageKey={storageKey}
                style={{ marginBottom: "1.5rem" }}
                rows={averageRatings}
                columns={columns}
                loading={loading}
                localeText={{ noRowsLabel: "No student average ratings" }}
                getRowId={(row) => `${row?.cohortId}-${row?.moduleId}-${row?.studentId}`}
                disableRowSelectionOnClick={false}
                onRowClick={(e) => setFilter({ ...filter, moduleId: e.row?.moduleId, studentId: e.row?.studentId })}
                exportName={`${storageKey}_${filter.cohortId}`}
            />
            {averageRatings?.length > 0 && <BaseOperations
                helpInfoTexts={[
                    "You can click on a row in the list to select the <b>Student</b>.",
                    "The average rating is given by <b>summarizing badge rating</b> and divide by the <b>number of badges</b> rated for the student."
                ]}
            />}
        </React.Fragment>
    );
}
